import axios from 'axios'
import customAxios from '@/axios/config'

export default {
  namespaced: true,
  state: {
    taxProfiles: [],
    listing_based_fees: {},
  },
  mutations: {
    updateTaxProfiles(state, payload) {
      state.taxProfiles = payload
    },
    updateListingBasedFees(state, payload) {
      state.listing_based_fees = payload
    },
  },
  actions: {
    async getTaxProfiles({ commit }) {
      const { data } = await axios.get(
        'api/tax-profiles/stats?include_listing_ids=true'
      )
      commit('updateTaxProfiles', data)
      // Also store listing_based_fees mapping if provided
      if (data.listing_based_fees) {
        commit('updateListingBasedFees', data.listing_based_fees)
      }
      return data
    },
    async getTaxProfile(store, { taxProfileId } = {}) {
      return axios
        .get(`/api/tax-profiles/${taxProfileId}/`)
        .catch(console.error)
    },
    async updateTaxProfile({ dispatch }, { id, ...payload }) {
      const taxId = id || payload?.tax_profile?.id
      await customAxios.put(`/api/tax-profiles/${taxId}`, payload)
      dispatch('getTaxProfiles')
    },
    async createTaxProfile({ dispatch }, payload) {
      await customAxios.post(`/api/tax-profiles`, payload)
      dispatch('getTaxProfiles')
    },
    async deleteTaxProfile({ dispatch }, id) {
      await customAxios.delete(`/api/tax-profiles/${id}`)
      dispatch('getTaxProfiles')
    },
  },
}
